export default __webpack_public_path__ + "static/media/sflex_thumb_home_2.11a2bc8b.png";